import React from 'react'
import styles from './pageNotFound.module.scss'

export default function PageNotFound() {
    return (
        <div className={styles.container}>
           404, Страница не найдена
        </div>
    )
}
